export const REFRESH_TOKEN_COOKIE = 'auth_refresh_token';
export const ACTIVE_USER_ID_KEY = 'auth_active_user_id';

export const refreshTokenCookieName = (userId?: string): string =>
    userId ? `${REFRESH_TOKEN_COOKIE}_${userId}` : REFRESH_TOKEN_COOKIE;

export const getActiveUserId = (): string | undefined => sessionStorage.getItem(ACTIVE_USER_ID_KEY) ?? undefined;
export const setActiveUserId = (userId: string): void => sessionStorage.setItem(ACTIVE_USER_ID_KEY, userId);
export const clearActiveUserId = (): void => sessionStorage.removeItem(ACTIVE_USER_ID_KEY);
